const containers = document.querySelectorAll(".tooltip-container")

if (containers.length) {
  const closeAll = (except) => {
    containers.forEach((container) => {
      if (container === except) return

      container.classList.remove("is-expanded")
      container.querySelector(".tooltip-toggle")?.setAttribute("aria-expanded", "false")
    })
  }

  containers.forEach((container) => {
    const toggle = container.querySelector(".tooltip-toggle")

    if (!toggle) return

    toggle.addEventListener("click", () => {
      const isExpanded = container.classList.contains("is-expanded")

      closeAll(container)
      container.classList.toggle("is-expanded", !isExpanded)
      toggle.setAttribute("aria-expanded", String(!isExpanded))
    })
  })

  document.addEventListener("click", (event) => {
    const withinContainer = Array.from(containers).some((container) => container.contains(event.target))

    if (!withinContainer) {
      closeAll()
    }
  })

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeAll()
    }
  })
}
